// extracted by mini-css-extract-plugin
export default {"largeTitlesBlack":"dpoInternal_largeTitlesBlack__8Tva5"};